import React from 'react';

import { QuestionSummary } from './summary';

import type { AskUserQuestionsToolCall } from './types';

interface Props {
  superseded: boolean;
  toolCall: AskUserQuestionsToolCall;
}

export function Question({ superseded, toolCall }: Props) {
  const { answers, dismissed, questions } = toolCall.metadata;

  // Closing the card is its own answer - the questions were the wrong ones - so it reads differently
  // from a card the user simply talked past. Checked first because spending a card always writes
  // both keys, which leaves a dismissal carrying a row of empty answers.
  if (dismissed) {
    return <QuestionSummary answers={null} note="Closed without answering" questions={questions} />;
  }

  if (answers) {
    return <QuestionSummary answers={answers} note={null} questions={questions} />;
  }

  // Only a message the user typed past the card retires it. An attempt that failed leaves it live,
  // so they can answer again from the same card rather than starting over.
  if (superseded) {
    return <QuestionSummary answers={null} note="Not answered" questions={questions} />;
  }

  return (
    <div className="small text-muted">
      {questions.length > 1 ? 'Asking follow-up questions' : 'Asking a follow-up question'}
    </div>
  );
}
